/*============================================================================
  Cart drawer gift note
  - Saves the message to the "Gift note" cart attribute as the customer
    types, so it is on the order (Additional details) in Shopify admin
  - Clearing the box removes the attribute
==============================================================================*/
(function() {
  var root = document.querySelector('[data-cart-gift-note]');

  if (!root || !window.theme || !theme.cart) {
    return;
  }

  var input = root.querySelector('[data-gift-note-input]');
  var count = root.querySelector('[data-gift-note-count]');
  var saved = input.value.trim();
  var timer;

  function save() {
    clearTimeout(timer);
    var value = input.value.trim();
    if (value === saved) {
      return;
    }
    saved = value;
    theme.cart.updateAttribute('Gift note', value);
  }

  input.addEventListener('input', function() {
    count.textContent = input.value.length;
    clearTimeout(timer);
    timer = setTimeout(save, 600);
  });

  input.addEventListener('change', save);

  // Focus the box when the row is opened
  root.addEventListener('toggle', function() {
    if (root.open) {
      input.focus({ preventScroll: true });
    }
  });
})();
